import { useState } from "react";

export function useCommunicationsData(supabase, landlordId, session, reload) {
  const [communications, setCommunications] = useState([]);
  const [showCommLog, setShowCommLog] = useState(null);
  const [showAddComm, setShowAddComm] = useState(false);
  const [newComm, setNewComm] = useState({ tenant: "", type: "Phone Call", subject: "", body: "", date: new Date().toISOString().slice(0,10), priority: "normal" });
  const [commSearch, setCommSearch] = useState("");
  const [commCatFilter, setCommCatFilter] = useState("");
  const [commPriFilter, setCommPriFilter] = useState("");
  const [commTenantFilter, setCommTenantFilter] = useState("");
  const [commDateFrom, setCommDateFrom] = useState("");
  const [commDateTo, setCommDateTo] = useState("");

  const addComm = async () => {
    if (!newComm.tenant || !newComm.subject) return;
    setShowAddComm(false);
    const { error } = await supabase.from("communications").insert([{
      tenant: newComm.tenant, type: newComm.type, subject: newComm.subject,
      body: newComm.body || null, date: newComm.date, user_id: landlordId,
      priority: newComm.priority || "normal", logged_by: session?.user?.email || "admin",
    }]);
    if (error) { alert("Error saving note: " + error.message); return; }
    setNewComm({ tenant: "", type: "Phone Call", subject: "", body: "", date: new Date().toISOString().slice(0,10), priority: "normal" });
    reload();
  };

  const deleteComm = async (id) => {
    if (!window.confirm("Delete this log entry?")) return;
    await supabase.from("communications").delete().eq("id", id);
    reload();
  };

  return {
    communications, setCommunications,
    showCommLog, setShowCommLog,
    showAddComm, setShowAddComm,
    newComm, setNewComm,
    commSearch, setCommSearch,
    commCatFilter, setCommCatFilter,
    commPriFilter, setCommPriFilter,
    commTenantFilter, setCommTenantFilter,
    commDateFrom, setCommDateFrom,
    commDateTo, setCommDateTo,
    addComm, deleteComm,
  };
}
